import { TicketNotificationEvent, TicketNotificationRecipient } from "../service/Companies";

export type CompanyNotificationConfig = Partial<Record<TicketNotificationEvent, TicketNotificationRecipient[]>>;

export const NOTIFICATION_RECIPIENT_LABELS: Record<TicketNotificationRecipient, string> = {
  team: "notifications.ticket.notif_recipient_team",
  teamSupervisor: "notifications.ticket.notif_recipient_teamSupervisor",
  responsible: "notifications.ticket.notif_recipient_responsible",
  requester: "notifications.ticket.notif_recipient_requester",
};

export const NOTIFICATION_EVENT_LABELS: Record<TicketNotificationEvent, string> = {
  opened: "notifications.ticket.notif_event_opened",
  accepted: "notifications.ticket.notif_event_accepted",
  approved: "notifications.ticket.notif_event_approved",
  rejected: "notifications.ticket.notif_event_refused",
  inProgress: "notifications.ticket.notif_event_inProgress",
  completed: "notifications.ticket.notif_event_completed",
  canceled: "notifications.ticket.notif_event_cancelled",
  closed: "notifications.ticket.notif_event_closed",
  reopened: "notifications.ticket.notif_event_reopened",
  deadlineReached: "notifications.ticket.notif_event_deadlineReached",
  priorityChanged: "notifications.ticket.notif_event_priorityChanged",
  commented: "notifications.ticket.notif_event_newInteraction",
};

export const ALL_NOTIFICATION_EVENTS = Object.keys(NOTIFICATION_EVENT_LABELS) as TicketNotificationEvent[];

export const ALL_NOTIFICATION_RECIPIENTS = Object.keys(NOTIFICATION_RECIPIENT_LABELS) as TicketNotificationRecipient[];
